import React from "react";

const activities = [
  {
    text: "saraswati.ribbons@gmail.com submitted this document",
    time: "Date & time",
  },
  {
    text: "saraswati.ribbons@gmail.com changed value of status from draft to submitted",
    time: "1 month ago",
  },
  {
    text: "saraswati.ribbons@gmail.com created this",
    time: "1 month ago",
  },
  {
    text: "saraswati.ribbons@gmail.com edited",
    time: "1 month ago",
  },
  {
    text: "saraswati.ribbons@gmail.com created this",
    time: "1 month ago",
  },
];

const Activities = () => {
  return (
    <div className="col-6 mt-3 ms-3">
      <h6 className="fw-bold mb-3">Activities</h6>

      {activities.map((item, index) => (
        <div key={index} className="d-flex justify-content-between mb-2">
          {/* Left content */}
          <div className="d-flex">
            <div
              style={{
                width: "3px",
                backgroundColor: "#D97706",
                marginRight: "10px",
                borderRadius: "2px",
              }}
            ></div>

            <div style={{ fontSize: "13px", color: "#0F0109" }}>
              {item.text}
            </div>
          </div>

          {/* Right time */}
          <div
            style={{
              fontSize: "12px",
              color: "#4B002B",
              whiteSpace: "nowrap",
            }}
          >
            {item.time}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Activities;
